import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { DiffMetadataProps } from 'src/components/diff-set/diff-set';
import {
  getDeleteBranchDialogSlice,
  closeDeleteBranchDialog,
} from 'src/redux/branches';
import { getIsDiffSettingsDialogOpen } from 'src/redux/diff-settings';
import { getIsViewEntireFileDialogOpen } from 'src/redux/pull-request/view-entire-file-reducer';
import { getBranchViewDestinationBranch } from 'src/redux/repository/branch/branch-redux';
import { DiffSettingsDialog } from 'src/sections/repository/sections/pull-request/components/diff-settings/index';
import { useBranchViewEntireFileState } from 'src/sections/repository/sections/pull-request/components/view-entire-file/hooks';
import { ViewEntireFileDialog } from 'src/sections/repository/sections/pull-request/components/view-entire-file/index';
import {
  getCurrentRepositorySlug,
  getCurrentRepositoryOwnerName,
} from 'src/selectors/repository-selectors';

import DeleteBranchDialog from '../../branches/components/dialogs/delete-branch-dialog';
import BranchMergeDialog from '../containers/branch-merge-dialog';
import { useDeleteBranch } from '../hooks/delete-branch';

type Props = {
  branchName: string;
  diffMetadataProps: DiffMetadataProps;
};

export const BranchDialogZone = ({
  branchName,
  diffMetadataProps,
}: Props): JSX.Element => {
  const isViewEntireFileDialogOpen = useSelector(getIsViewEntireFileDialogOpen);
  const isDiffSettingsDialogOpen = useSelector(getIsDiffSettingsDialogOpen);
  const deleteBranch = useDeleteBranch();
  const { isOpen, isDeleting } = useSelector(getDeleteBranchDialogSlice);
  const dispatch = useDispatch();
  const slug = useSelector(getCurrentRepositorySlug);
  const owner = useSelector(getCurrentRepositoryOwnerName);
  const destinationBranch = useSelector(getBranchViewDestinationBranch);

  return (
    <ModalTransition>
      {isViewEntireFileDialogOpen && (
        <ViewEntireFileDialog
          useViewEntireFileState={useBranchViewEntireFileState}
          allowComments={false}
          diffMetadataProps={diffMetadataProps}
        />
      )}
      {isDiffSettingsDialogOpen && <DiffSettingsDialog disableAnnotations />}
      <DeleteBranchDialog
        isOpen={isOpen}
        isDeleting={isDeleting}
        branchName={branchName}
        onClose={() => dispatch(closeDeleteBranchDialog())}
        onDelete={() => deleteBranch({ branchName, owner, slug })}
      />
      <BranchMergeDialog destinationBranch={destinationBranch} />
    </ModalTransition>
  );
};
